import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import _ from "lodash";

const JobSummary = (props) => (
  <Row>
    <Col>
      <Card border="light" className="shadow dashboardStats">
        <Card.Body>
          <Row>
            <Col xs="4" lg="4">
              <div
                style={{ cursor: "pointer" }}
                title="View all Backlogs (Till date)"
                onClick={() => props.onFilter(1)}
              >
                <span className="d-flex justify-content-center align-items-center">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/delayed.png`}
                    width="50"
                    height="50"
                    className="d-inline-block align-top me-2"
                    alt="Delayed"
                  />
                  <span className="title me-2">
                    {_.get(props, "stats.backlog", "-")}
                  </span>
                  <span>
                    <span className="d-block mb-2 subtitle">Backlog</span>{" "}
                    <small>(Till date)</small>
                  </span>
                </span>
              </div>
            </Col>
            <Col xs="4" lg="4">
              <div
                style={{ cursor: "pointer" }}
                title="View all Upcoming (Today)"
                onClick={() => props.onFilter(2)}
              >
                <span className="d-flex justify-content-center align-items-center">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/upcoming.png`}
                    width="50"
                    height="50"
                    className="d-inline-block align-top me-2"
                    alt="Upcoming"
                  />
                  <span className="title me-2">
                    {_.get(props, "stats.upcoming", "-")}
                  </span>
                  <span>
                    <span className="d-block mb-2 subtitle">Upcoming</span>
                    <small>(Today)</small>
                  </span>
                </span>
              </div>
            </Col>
            <Col xs="4" lg="4">
              <div
                style={{ cursor: "pointer" }}
                title="View all Complete (This Week)"
                onClick={() => props.onFilter(3)}
              >
                <span className="d-flex justify-content-center align-items-center">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/completed.png`}
                    width="50"
                    height="50"
                    className="d-inline-block align-top me-2"
                    alt="Completed"
                  />
                  <span className="title me-2">
                    {_.get(props, "stats.completed", "-")}
                  </span>
                  <span>
                    <span className="d-block mb-2 subtitle">Complete</span>
                    <small>(This Week)</small>
                  </span>
                </span>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  </Row>
);

export default JobSummary;
